/**
 * Created by fajar on 06/25/2018.
 * Updated by cahyo
 *
 * Entity for menu property with extending BaseEntity
 * and rule logic for serialize (wrapping) and
 * deserialize (explain) property
 */

import {deserialize, inheritSerialization, serialize} from "cerialize";
import {kebabCase} from 'lodash';

import BaseEntity from "./BaseEntity";

@inheritSerialization(BaseEntity)
export default class Menu extends BaseEntity {

  @deserialize
  public url: any = "";

  @deserialize
  public childs: Array<any> = [];

  @deserialize
  public name: string = "";

  @deserialize
  public icon: string = "";

  @deserialize
  public number: number = 0;

  @serialize
  @deserialize
  public parent: any = {};

  @deserialize
  public isActive: boolean = false;

  @deserialize
  public classNames: string = '';

  public static OnDeserialized(instance: Menu, json: any): void {
    instance.icon = 'far ';

    if (instance.url === null) {
      instance.url = '/' + kebabCase(json.name);
    }

    switch (json.id) {
      case 2:
        instance.icon += 'fa-books';
        break;
      case 3:
        instance.icon += 'fa-money';
        break;
      case 4:
        instance.icon += 'fa-building';
        break;
      case 5:
        instance.icon += 'fa-book-reader';
        break;
      case 6:
        instance.icon += 'fa-users-class';
        break;
      case 7:
        instance.icon += 'fa-group';
        break;
      case 8:
        instance.icon += 'fa-money';
        break;
      case 9:
        instance.icon += 'fa-money';
        break;
      case 10:
        instance.icon += 'fa-group';
        break;
      case 11:
        instance.icon += 'fa-university';
        break;
      case 12:
        instance.icon += 'fa-store';
        break;
      case 13:
        instance.icon += 'fa-cogs';
        break;
      case 59:
        instance.icon += 'fa-store';
        break;
      case 60:
        instance.icon += 'fa-chart-line';
        break;
      case 61:
        instance.icon += 'fa-tachometer-alt';
        break;
      case 62:
        instance.icon += 'fa-tags';
        break;
      case 63:
        instance.icon += 'fa-box';
        break;
      case 64:
        instance.icon += 'fa-file-import';
        break;
      case 65:
        instance.icon += 'fa-arrow-circle-down';
        break;
      case 66:
        instance.icon += 'fa-arrow-circle-up';
        break;
      case 67:
        instance.icon += 'fa-history';
        break;
      case 69:
        instance.icon += 'fa-receipt';
        break;
      case 70:
        instance.icon += 'fa-chart-bar';
        break;
      case 71:
        instance.icon += 'fa-money-bill-wave';
        break;
      case 72:
        instance.icon += 'fa-clipboard-list';
        break;
      default:
        instance.icon += 'fa-file-invoice';
        break;
    }
  }
}
